// extracted by mini-css-extract-plugin
export default {"verifybtn":"ClassActivitiesTab_verifybtn__HHE7D","actionWrap":"ClassActivitiesTab_actionWrap__vYdkH"};